import { render, staticRenderFns } from "./student-list.vue?vue&type=template&id=3e1d4c9d&"
import script from "./student-list.vue?vue&type=script&lang=js&"
export * from "./student-list.vue?vue&type=script&lang=js&"
import style0 from "./student-list.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports